import {combineReducers} from "redux";
import { reducer as formReducer } from 'redux-form';

import catagorylist from "./reducer_catagoryList";
import singleCategory from "./reducer_singleCategory";
import shoppingCartItems from './reducer_shoppingCartItems';
import userToken from './reducer_usertoken';
import regionReducer from './reducer_region'
const rootReducer = combineReducers({
  catagorylist: catagorylist,
  singleCategory: singleCategory,
  shoppingCartItems: shoppingCartItems,
  userToken: userToken,
  form: formReducer,
  region: regionReducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js